import React from 'react'
import { useHistory } from 'react-router-dom'

// styles
import './Calendar.css'

export default function Calendar({ dates, rootPath = '/schedule/jobDay/' }) {
    let history = useHistory()

    return (<table className='calendar'>
        <thead>
            <tr>
                <th>
                    <div>{dates[0]['number']}</div>
                    <div>Monday</div>
                </th>
                <th>
                    <div>{dates[1]['number']}</div>
                    <div>Tuesday</div>
                </th>
                <th>
                    <div>{dates[2]['number']}</div>
                    <div>Wednesday</div>
                </th>
                <th>
                    <div>{dates[3]['number']}</div>
                    <div>Thursday</div>
                </th>
                <th>
                    <div>{dates[4]['number']}</div>
                    <div>Friday</div>
                </th>
                <th>
                    <div>{dates[5]['number']}</div>
                    <div>Saturday</div>
                </th>
                <th>
                    <div>{dates[6]['number']}</div>
                    <div>Sunday</div>
                </th>
            </tr>
        </thead>
        
        <tbody>
            <tr>
                {
                    dates.map(date => {
                        return (<td key={`${date.label}-calendar-column`}>
                            {
                                date.jobDays.map(jobDay => {
                                    return (<div 
                                        className='calendar-job-day'
                                        key={`jobDay-calendar-box-${jobDay.id}`}
                                        onClick={() => history.push(`${rootPath}${jobDay.id}`)}
                                     >
                                        <div className='calendar-job-day-title'>{jobDay.title}</div>
                                        <div className='calendar-job-day-time'>{jobDay.time}</div>
                                    </div>)
                                })
                            }
                        </td>)
                    })
                }
            </tr>
            
        </tbody>
    </table>)
}